export default __webpack_public_path__ + "static/media/page_crypted_instruction.d7bb6002.png";